import { useQuery } from "@tanstack/react-query";
import { queryCommonFlags } from "@/api/constants";
import { getPropertyTypesV2 } from "@/modules/common/api/index.v2";

const usePropertyTypesFilterOptions = () => {
  const {
    data: propertyTypes,
    error: propertyTypesError,
    isLoading: propertyTypesLoading,
  } = useQuery({
    queryKey: ["propertyTypes"],
    queryFn: () => getPropertyTypesV2(),
    ...queryCommonFlags,
    staleTime: 60000,
  });

  return {
    propertyTypes: propertyTypes?.data,
    propertyTypesError,
    propertyTypesLoading,
  };
};

export default usePropertyTypesFilterOptions;
